import request from '@/utils/request'
import { randomToken } from '@/utils/auth.js'
import https from '@/utils/https.js'
// export function getEvaluationDetail(evaluation_id) {
//     return request({
//         url: '/web/Evaluation/getEvaluationDetail',
//         method: 'post',
//         data: {
//             evaluation_id: evaluation_id,
//         }
//     })
// }

export function getQuestionList(test_id) {
    return https({
        url: '/api/psytest/detail',
        method: 'post',
        data: {
            test_id: test_id,
        }
    })
}

export function getResult(test_id, answer, start_time) {
    return request({
        url: '/web/psytest/submit_answer',
        method: 'post',
        data: {
            test_id: test_id,
            answer: JSON.stringify(answer),
            start_time: start_time,
            unique_code: randomToken()
        }
    })
}

export function getMajor(form) {
    return https({
        url: '/api/evaluation/get_profession',
        method: 'post',
        data: {
            area: localStorage.getItem('area'),
            subject_id: form.subject_id,
            subject: form.subject,
            gender: form.gender,
            score: form.score,
            local_batch_id: form.local_batch_id
        }
    })
}

export function addTest(form) {
    return request({
        url: '/web/evaluation/add_xymb',
        method: 'post',
        data: {
            test_id: form.test_id,
            area: localStorage.getItem('area'),
            subject_id: form.subject_id,
            subject: form.subject,
            gender: form.gender,
            score: form.score,
            local_batch_id: form.local_batch_id,
            // difficulty: form.difficulty,
            spname: form.spname
        }
    })
}